import React, {Component} from "react";
import {connect} from "react-redux";
import {api, apis, db_tables, DBHelpers, errors, msg, rd, sendGet, throws} from "../../../vars/rd";
import {preloaderHide, preloaderShow} from "../../../libs/redux/actions/preloader";
import {likeChange} from "../../../libs/redux/actions/like";

/**
 * 음원 좋아요 버튼
 */
class MediaLike extends Component {
    constructor(props) {
        super(props);

        this.msg = msg();

        this.type = this.props.type;
        this.callback = this.props.callback;

        this.state = {
            media: this.props.id,
            selected: this.props.selected,
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        // 곡 변경시 정보 업데이트
        try {
            if(this.props.id !== prevProps.id || this.props.type !== prevProps.type) {
                this.setState({
                    media: this.props.id,
                    selected: this.props.selected,
                });
            }
        } catch (e) {}

        try {
            const like = this.props && this.props.hasOwnProperty('like') ? this.props.like : false;
            if(like && this.props.id === like.id) {
                const selected = like.selected;
                if(this.state.selected !== selected)
                    this.setState({selected});
            }
        } catch (e) {}
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    get isFavorite() {
        try {
            return this.state.selected;
        } catch (e) {}
        return false;
    }

    /**
     * 즐겨찾기
     * @param e
     */
    async favorite(e) {
        e.stopPropagation();
        this.dispatch(preloaderShow());
        try {
            const next_state = !this.state.selected;
            const params = {
                serviceid: rd.user.serviceid,
                groupid: rd.user.groupid,
                songid: this.state.media,
            };
            const url = api(apis.media_favorite, params);
            const json = await sendGet(url);
            if(this.mounted) {
                if(!json || json.result !== "OK") throws(this.msg.api_fail);
                if(json.status === "OK") {
                    this.callbackCall(next_state);
                    // 최근재생의 경우는 디비 정보도 업데이트 한다.
                    const db = await DBHelpers.openDB();
                    await db.updateBulk(db_tables.history, {favorite: next_state ? 'Y' : 'N'}, doc => {
                        return doc.songid === params.songid &&
                            doc.groupid === params.groupid &&
                            doc.serviceid === params.serviceid;
                    });
                }
            }
        } catch (err) {
            errors(err);
        } finally {
            this.dispatch(preloaderHide());
        }
    }

    callbackCall(state) {
        if(this.callback) {
            this.callback.call(null, state);
        }

        if(this.dispatch) {
            // 전역 이벤트 전송
            this.dispatch(likeChange(this.state.media, state));
        }
    }

    render() {
        return (
            <span className={this.isFavorite ? 'on' : ''} onClick={e => this.favorite(e)}>
                <img src={`/images/icon-like${this.isFavorite ? '-on' : ''}.png`} alt='좋아요' />
                좋아요
            </span>
        );
    }
}

const likeStateToProps = (state) => {
    return {
        like: state.like
    };
};

export default connect(likeStateToProps)(MediaLike);


// WEBPACK FOOTER //
// ./src/pages/components/buttons/media.like.jsx